import { createContext, useContext, useReducer } from "react";
import customReportsReducer from "./custom-reports-reducer";
import { ContextConfigType } from "../models";

const CustomReportsContext: any = createContext({} as any) as any;
const CustomReportsDispatchContext: any = createContext({} as any) as any;

const initialConfig: ContextConfigType = {
  detail: null,
  updateSource: null,
  datasetConfig: null,
  columnConfig: null,
  conditionalsFormatting: null,
  gridState: null,
  gridStatusBudge: null,
  permissions: {
    canConfigureCustomReports: false
  }
};

export function CustomReportsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer(customReportsReducer, initialConfig);

  return (
    <CustomReportsContext.Provider value={state}>
      <CustomReportsDispatchContext.Provider value={dispatch}>
        {children}
      </CustomReportsDispatchContext.Provider>
    </CustomReportsContext.Provider>
  );
}

export function useCustomReports(): ContextConfigType {
  const contextData: ContextConfigType = useContext(CustomReportsContext);
  return contextData;
}

export function useCustomReportsDispatch() {
  const contextDispatch: any = useContext(CustomReportsDispatchContext);
  return contextDispatch;
}

export default CustomReportsContext;
